import React from "react";
import {Field, Form, Formik} from "formik";
import {Input} from "../../../../_metronic/_partials/controls";

export function ProductEditForm({
                                    product
                                }) {

    return (
        <>
            <Formik
                enableReinitialize={true}
                initialValues={product}
            >
                {({handleSubmit}) => (

                    <Form className="form form-label-right">

                        <div className="card card-custom gutter-b card-border card-fit">
                            <div className="card-header">
                                <div className="card-title">
                                    <h3 className="card-label">
                                        مشخصات محصول
                                    </h3>
                                </div>
                            </div>
                            <div className="card-body">
                                <div className="form-group row">
                                    <div className="col-lg-4">
                                        <Field
                                            name="title"
                                            component={Input}
                                            placeholder="عنوان"
                                            label="عنوان"
                                        />

                                    </div>
                                    <div className="col-lg-4">
                                        <Field
                                            name="brandName"
                                            component={Input}
                                            placeholder="برند"
                                            label="برند"
                                        />
                                    </div>
                                    <div className="col-lg-4">
                                        <Field
                                            name="color"
                                            component={Input}
                                            placeholder="رنگ"
                                            label="رنگ"
                                        />
                                    </div>
                                </div>

                                <div className="form-group row">
                                    <div className="col-lg-4">
                                        <Field
                                            name="categoryName"
                                            component={Input}
                                            placeholder="دسته بندی"
                                            label="دسته بندی"
                                        />
                                    </div>
                                    <div className="col-lg-4">
                                        <Field
                                            name="price"
                                            component={Input}
                                            placeholder="قیمت"
                                            label="قیمت"
                                        />
                                    </div>
                                    <div className="col-lg-4">
                                        {/*<Field*/}
                                        {/*    name="trendyolUrl"*/}
                                        {/*    component={Input}*/}
                                        {/*    placeholder="Trendyol URL"*/}
                                        {/*    label="Trendyol URL"*/}
                                        {/*/>*/}
                                        <a className="btn btn-primary d-block"
                                           target={"_blank"}
                                           href={`https://www.trendyol.com${product.trendyolUrl}`}
                                           >نمایش صفحه محصول
                                        </a>
                                    </div>
                                </div>

                            </div>
                        </div>

                    </Form>
                )}
            </Formik>
        </>
    );
}
